(function($){

    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                    Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
            var el = this;

            do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }

    $(document).ready(function() {
        //Load YT API scripts
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        //Parse youtube url and get video id
        function getIdFromUrl(url){
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            var match = url.match(regExp);
            return (match&&match[7].length===11)? match[7] : false;
        }

        //Variable to store reference to slick slider
        var homeSlider;

        //Variable to store reference to video popup
        var homeSliderPopup;

        //Video popup constructor
        var Popup = function(el) {
            var self = this;
            this.el = el;
            this.video_container = this.el.querySelector('.top-slider-popup__video');
            this.heading = this.el.querySelector('.top-slider-popup__heading');
            this.description = this.el.querySelector('.top-slider-popup__description');
            this.close = this.el.querySelector('.top-slider-popup__close');
            this.backface = this.el.querySelector('.top-slider-popup__before');
            this.url = undefined;

            this.__lockScroll = function() {
                document.documentElement.classList.add('fancybox-lock');
            }

            this.__unlockScroll = function() {
                document.documentElement.classList.remove('fancybox-lock');
            }

            this.__findIframe = function() {
                if (!self.iframe && self.el.querySelector('iframe')) {
                    self.iframe = self.el.querySelector('iframe').rel;
                }
            }

            this.__setDescription = function(title, descr) {
                self.heading.innerHTML = title;
                self.description.innerHTML = descr;
            }

            this.__pauseSlider = function() {
                homeSlider.slickPause();
                if (homeSlider.currentVideo) {homeSlider.currentVideo.pauseVideo();}
            }

            this.__playSlider = function() {
                homeSlider.slickPlay();
                if (homeSlider.currentVideo) {homeSlider.currentVideo.playVideo();}
            }

            this.__pauseVideo = function() {
                if (self.iframe) {self.iframe.pauseVideo();}
            }

            this.__playVideo = function() {
                if (self.iframe) {self.iframe.playVideo();}
            }

            this.__fadeIn = function() {
                self.el.classList.add('top-slider-popup_opened');
            }

            this.__fadeOut = function() {
                self.el.classList.remove('top-slider-popup_opened');
            }

            this.__processSettings = function() {
                var settings = self.settings;
                if (self.url !== settings.url) {
                    self.url = settings.url;
                    self.__setDescription(settings.title, settings.descr);
                    self.iframe.loadVideoById(getIdFromUrl(settings.url));
                }
            }

            this.__createIframe = function() {
                var settings = self.settings;
                self.url = settings.url;
                self.__setDescription(settings.title, settings.descr);
                appendIframe(self.video_container, true, settings.url);
            }

            this.__show = function(settings) {
                self.settings = settings;
                self.__findIframe();
                self.__pauseSlider();
                self.__lockScroll();
                self.iframe ? self.__processSettings() : self.__createIframe();
                self.__fadeIn();
            };

            this.__hide = function() {
                self.__findIframe();
                self.__playSlider();
                self.__unlockScroll();
                self.__pauseVideo();
                homeSliderSetAutoplaySpeed(homeSliderGetVideoTimeDifference());
                self.__fadeOut();
            };

            this.close.addEventListener('click', this.__hide);
            this.backface.addEventListener('click', this.__hide);
        };

        ///Slick slider constructor
        var SlickSliderInitHomeTop = function(elem,sliderPaprms) {
            var self = this;
            this.wrapper = elem;
            this.sliderParams = sliderPaprms || {};

            this.wrapper.on('init', function(e, slick) {
                sliderNavReposition();
            })

            this._sliderInit = function() {
                self.wrapper.slick(this.sliderParams);
            };

            this.init = function() {
                self._sliderInit();
            };

            this.init();
        };

        function getCurrentSlickSlide(currentSlide) {
            return homeSlider.$slides.get(currentSlide);
        }

        function isThereActiveVideo(el) {
            return el.querySelector('iframe.loaded');
        }

        function appendIframe(el, is_popup_iframe, url) {
            var vid_container = el.querySelector('.video-container') || el,
                link = vid_container.getAttribute('data-short-video') || url,
                div = document.createElement('div');
            vid_container.appendChild(div);
            createIframe(link, div, is_popup_iframe);
        }

        function homeSliderBeforeChange(e, slick, currentSlide, nextSlide) {
            var self  = homeSlider;
            sliderNavReposition(slick, currentSlide, nextSlide);
            if (self.currentVideo) {
                self.currentVideo.pauseVideo();
                self.currentVideo.seekTo(0, true);
            }
        }

        function homeSliderAfterChange() {
            var self = homeSlider,
                slide = getCurrentSlickSlide(self.currentSlide);
            if (!slide.classList.contains('with_video')) {
                homeSliderSetAutoplaySpeed(homeSlider.defaultInterval);
                homeSlider.currentVideo = null;
                return;
            }
            var active_video = isThereActiveVideo(slide);
            if (active_video) {
                homeSlider.currentVideo = active_video.ref;
                homeSliderPlayCurrentVideo();
            } else {
                appendIframe(slide);
            }
        }

        function sliderNavReposition(slick, currentSlide, nextSlide) {
            if (window.innerWidth > 768) return null;
            var s;
            if (nextSlide === undefined) {
                s = document.querySelector('.home-top-slider .slick-slide.slick-active');
            } else {
                s = document.getElementById('slide-'+(nextSlide+1));
            }
            var banner_height = Number(s.querySelector('.slide__description').getBoundingClientRect().height);
            document.querySelector('.home-top-slider__dots').style.transform = 'translate(-50%, -' + (banner_height + 10) + 'px)';
            var arrow_height = Number(document.querySelector('.home-top-slider__arrow').getBoundingClientRect().height);
            var arrow_bottom = (banner_height/2 - arrow_height/2) + 'px';
            document.querySelector('.home-top-slider__arrow.prev').style.bottom = document.querySelector('.home-top-slider__arrow.next').style.bottom = arrow_bottom;
        }

        function homeSliderGetVideoTimeDifference() {
            var dur = homeSlider.currentVideo.getDuration();
            var cur = homeSlider.currentVideo.getCurrentTime();
            var diff = dur - cur || 0;
            if (diff < 0 ) {
                homeSlider.currentVideo.seekTo(0, true);
                return dur*1000;
            } else {
                return diff*1000;
            }
        }

        function homeSliderPlayCurrentVideo() {
            homeSlider.currentVideo.playVideo();
            homeSliderSetAutoplaySpeed(homeSlider.currentVideo.getDuration()*1000);
        }

        function homeSliderSetAutoplaySpeed(speed) {
            homeSlider.slickPause();
            homeSlider.setOption('autoplaySpeed', speed - 100);
            homeSlider.slickPlay();
        }

        function onPlayerReady(e) {
            console.log(e.target)
            var player = e.target,
                is_popup_opened = document.querySelector('.top-slider-popup_opened') !== null,
                is_popup_iframe = player.g.closest('.top-slider-popup') !== null;

            player.g.classList.add('loaded');
            player.g.ref = player;
            if (!is_popup_iframe) {player.mute();}
            if (is_popup_iframe) {
                homeSliderPopup.iframe = player;
                if (is_popup_opened) {
                    player.playVideo();
                }
            } else if (!(is_popup_opened && is_popup_iframe && player.closest('.slick-current'))) {
                // player.g.closest('.slide').querySelector('.lds-facebook').style.opacity = 0;
                homeSlider.currentVideo = player;
                homeSliderPlayCurrentVideo();
            }
        }

        function checkCurrentTime() {
            if (this.getDuration() - this.getCurrentTime() <= .5) {
                clearTimeCheckInterval(this)
            }
        }

        function clearTimeCheckInterval(player) {
            player.checkCurrentTime = null;
            player.g.classList.remove('visible');
        }

        function onSliderPlayerStateChange(e) {
            var player = e.target;
            if (document.querySelector('.top-slider-popup_opened') && !player.g.closest('.slick-current')) {
                clearTimeCheckInterval(player);
                return;
            }
            if (e.data === YT.PlayerState.ENDED) {
                player.playVideo();
            }
            if (e.data === YT.PlayerState.PLAYING) {
                if (!player.g.classList.contains('visible') || !player.checkCurrentTime) {
                    player.checkCurrentTime = setInterval(checkCurrentTime.bind(player), 100);
                    homeSliderSetAutoplaySpeed(homeSliderGetVideoTimeDifference());
                }
                player.g.classList.add('visible');
            }
        }

        function onPopupPlayerStateChange(e) {
            return;
        }

        function createIframe(url, el, is_popup_iframe) {
            new YT.Player(el, {
                videoId: getIdFromUrl(url),
                playerVars: {
                    playsinline: 1,
                    allowsInlineMediaPlayback: true,
                },
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': is_popup_iframe ? onPopupPlayerStateChange : onSliderPlayerStateChange
                }
            });
        }

        function processImageSlide(el) {
            const img = el.querySelector('img');
            var cont = el.querySelector('.image-container');
            cont.style.backgroundImage = 'url("'+img.src+'")';
            img.style.display = 'none';
        }

        function processVideoSlide(el, index) {
            if (index === 0) {
                appendIframe(el, false);
            }
            el.addEventListener('click', function(e) {
                const desc_bar = this.querySelector('.slide__description');
                if (e.composedPath().indexOf(desc_bar) != -1) {
                    return null;
                }
                var container = this.querySelector('.video-container');
                var url = container.getAttribute('data-url');
                var title = container.getAttribute('data-caption');
                var descr = container.getAttribute('data-descr');
                homeSliderPopup.__show({
                    url: url,
                    title: title,
                    descr: descr
                });
            })
        }

        window.onYouTubeIframeAPIReady = function() {
            if (document.querySelector('.home-top-slider')) {
                homeSliderPopup = new Popup(document.querySelector('#top-slider-popup'));
                var sliderEl = $(".home-top-slider");
                sliderEl.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
                    homeSliderBeforeChange(e, slick, currentSlide, nextSlide);
                });
                sliderEl.on('afterChange', homeSliderAfterChange);
                sliderEl.on("init", function(e, slick){
                    homeSlider = slick;
                    homeSlider.defaultInterval = slick.getOption('autoplaySpeed');
                    sliderNavReposition()
                    Array.prototype.slice.call(homeSlider.$slides).forEach(function(el, index) {
                        if (el.classList.contains('with_video')) {
                            processVideoSlide(el, index);
                        } else {
                            processImageSlide(el);
                        }
                    });
                });
                new SlickSliderInitHomeTop(sliderEl,{
                    slidesToShow: 1,
                    autoplay:false,
                    autoplaySpeed: 10000,
                    dots:true,
                    fade:false,
                    arrows:true,
                    speed:300,
                    lazyLoad:"progressive",
                    dotsClass:'home-top-slider__dots',
                    customPaging: function(slider, i) {
                        return '<div class="home-top-slider__dot"></div>';
                    },
                    prevArrow: '<div class="home-top-slider__arrow prev"><i class="fa fa-chevron-right"></i></div>',
                    nextArrow: '<div class="home-top-slider__arrow next"><i class="fa fa-chevron-right"></i></div>',
                    pauseOnDotsHover:false,
                    pauseOnHover:false,
                    adaptiveHeight:false,
                    draggable: false,
                    adaptiveHeight: true,
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            draggable: true
                        }
                    }],
                    cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
                });
            }
        }
    });
})(jQuery);
